<template>
    <div>
      <BaseModal
        v-if="visible" 
        ModalId="modalId"
        :HideModalFun="onHidden"
        :TitleWindow="$t('ItemsReceivedListRep.ReportTitle')"
        :width="'40%'"
        :height="'auto'"
        :buttons="[
            { text: $t('Shared.BtnCancel'), variant: 'secondary', action: 'Close' },
            { text: $t('Shared.TitleOK'), variant: 'primary', action: onClickShowReport },                   
        ]"              
        @Close="close">
            
        <b-row>
          <b-col lg="6" md="6" sm="12">
            <MdDateTime 
              :Label="$t('Shared.datefrom')" 
              :Model="dateFrom"                           
              @input="dateFrom = $event"                            
              :Id="'AdmissionDateFrom'"
              :Type="'date'"                  
              :isRequired="false" 
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="this.isDateFromValid">
            </MdDateTime>
          </b-col>
          <b-col lg="6" md="6" sm="12">
            <MdDateTime 
              :Label="$t('Shared.dateTo')" 
              :Model="dateTo"                           
              @input="dateTo = $event"                            
              :Id="'AdmissiondateTo'"
              :Type="'date'"                  
              :isRequired="false" 
              :isConfirm="false"
              :ReadOnly="false"
              v-bind:isValid="this.isDateToValid">
            </MdDateTime>
          </b-col>
        </b-row>
        <b-row>
          <b-col>         
            <MdSelect
              v-bind:Label="$t('Medication.Drugs')"
              v-bind:Options="DrugList"
              v-bind:Model="DrugsCodeModel"
              v-bind:FieldDescription="'drugname'"
              v-bind:FieldCode="'drugCode'"
              v-bind:Multiple="true"             
              :Input="ChangeDrugs"/>
          </b-col>
         </b-row>
        <b-row>
          <b-col>
            <MdSelect
                v-bind:Label="$tc('ePharmacyItemsReceived.Location')"
                v-bind:Options="LocList"
                v-bind:Model="LocCodeModel"
                v-bind:FieldDescription="'name'"
                v-bind:FieldCode="'code'" 
                v-bind:Multiple="true"                      
                :Input="ChangeLocation"/>
          </b-col>
        </b-row>
      </BaseModal>

      <DxPopup
        :visible="isReportVisible"
        :drag-enabled="true"
        :close-on-outside-click="false"
        :show-close-button="true"
        :show-title="true"
        :hide-on-parent-scroll="true"
        :title="$t('ItemsReceivedListRep.ReportTitle')"
        @hidden="onHiddenReport"
        :resize-enabled="true"
        shading-color="rgba(0, 0, 0, 0.5)"
        height="94vh"
        width="97vw"
        @showing="onShowing"
      >
        <ReportViewer
          ref="ItemsReceivedList"
          :ReportName="'ItemsReceivedList'"
          :ReportTitle="$t('ItemsReceivedListRep.ReportTitle')"
          :IsAnAPIReport="true"
        />
    </DxPopup>
  </div>
</template>

<script>
    import Vue from 'vue'
    import { DxPopup } from 'devextreme-vue/popup';
    import ShowMessage from '@/components/messages/ShowMessage.js'
    import DBFunctions from '@/common/DBFunctions.js'
    import PharmacyRepFunctions from '@/common/PharmacyRepFunctions.js'
    import Utils from '@/common/utils'
  
    export default Vue.extend({
        name: "ItemsReceivedFiltersRep",
        mixins: [ ShowMessage, DBFunctions, PharmacyRepFunctions ],
        components: { DxPopup },
        props: {
          closeWindow: Function,
          visible: {
            type: Boolean,
            default: false
          },
        },
        data() {
            return {
                isParamVisible: true,
                isReportVisible: false,
                emitCloseEvent: false,
                dateFrom: null,
                dateTo:null,
                reportParams: [],
                modalId: 'itemsReceivedFilter',
                DrugList:[],
                DrugsCodeModel:'',
                LocCodeModel:'',
                LocList:[],
                params: {
                  DrugList: '',
                  LocList: ''
                },
                isDateFromValid: true,
                isDateToValid: true,
            }
        },
        watch: {
          visible(newVal) {
            if (newVal) {
                this.$bvModal.show(this.modalId);
                this.emitCloseEvent= true;
            } 
          },
        },
        methods: {

          onShowing(e) {
            let contentElement = e.component.content();
            let titleElement = e.component._$title[0]
            contentElement.style.padding = '0px';
            titleElement.style.padding = '0px 20px'
          },

          onHiddenReport() {
            this.isReportVisible = false
            this.closeWindow()
          },

          close() {
            this.emitEventCancel();
          },

          initializePdfParameters() {
            this.reportParams = []
            this.reportParams.push({ paramName: 'pStartDate', paramValue: this.dateFrom})
            this.reportParams.push({ paramName: 'pEndDate', paramValue: this.dateTo})
            this.reportParams.push({ paramName: 'pLocations', paramValue: this.params.LocList})
            this.reportParams.push({ paramName: 'pDrogList',paramValue: this.params.DrugList })
            this.reportParams.push({ paramName: 'isUAE',  paramValue: this.$store.state.companies.isUAE})
          },

          onClickShowReport() {
            if (this.visible && !this.validateForm()) return;
            if (this.visible) this.onHidden();
            
            this.initializePdfParameters();
            this.isReportVisible = true
            this.$refs.ItemsReceivedList.buildDocument(this.reportParams)
          },

          onHidden() {
            if (this.emitCloseEvent) {
              this.emitCloseEvent= false;
              this.$emit('close');
            }
          },

          emitEventCancel() {
            this.emitCloseEvent= false;
            this.$emit('close');
          },

          validate_date_range() {
            return Utils.isDateFromAndDateTo(this.dateFrom, this.dateTo);
          },

          // Método de validación reutilizable
          validateForm() {
            if (!this.validate_date_range()) {
              this.showMessage(this.$tc('Msg.Error'), this.$t('Msg.DateOutRange'), "error");
              return false;
            }
            return true;
          },
        },
        mounted () {
          this.getDrugsFilter();
          this.getLocationsFilter();
        }
          
    })
</script>
<style>
  .dxrd-report-preview-holder {  
      height: 94% !important; 
  } 
</style>
